/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_ReloadInputs */

const cs_draft_reload = /** @type {(inputs: Draft_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit koncept`)
};

const en_draft_reload = /** @type {(inputs: Draft_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload draft`)
};

/**
* | output |
* | --- |
* | "Reload draft" |
*
* @param {Draft_ReloadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_reload = /** @type {((inputs?: Draft_ReloadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_ReloadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_reload(inputs)
	return cs_draft_reload(inputs)
});